import React from 'react'
import { Grid } from './Grid'
import { GridCell } from './GridCell'
import clsx from 'clsx'

export const FormBoxHeader = (props) => {
  const { title, children, mid = false, hide, className } = props

  if (hide === true) {
    return null
  }

  return <Grid marginX className={clsx(
    mid === false && 'slider-head-divider',
    mid === true && 'slider-mid-divider',
    className
  )}>
    <GridCell medium={12}>{title}
      <hr />
    </GridCell>
    {children
      ? <GridCell medium={12}>
        {children}
      </GridCell>
      : null
    }
  </Grid>
}
